/* tslint:disable */
/* eslint-disable */
/**
 * Client Logging API
 * Schnittstellen/API Definition für den Microservice client-logging-service.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export const Geraet = {
    Phone: 'phone',
    Tablet: 'tablet',
    Desktop: 'desktop'
};
/**
 * Log-Level
 * @export
 * @enum {string}
 */
export const LogLevel = {
    Trace: 'TRACE',
    Debug: 'DEBUG',
    Info: 'INFO',
    Warn: 'WARN',
    Error: 'ERROR'
};
/**
 * IncidentsApi - axios parameter creator
 * @export
 */
export const IncidentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Loggt ein übergebenes Incident aus dem Client.
         * @param {Incident} incident
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIncident: async (incident, options = {}) => {
            // verify required parameter 'incident' is not null or undefined
            assertParamExists('postIncident', 'incident', incident);
            const localVarPath = `/pc/v1/incidents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(incident, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * IncidentsApi - functional programming interface
 * @export
 */
export const IncidentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = IncidentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Loggt ein übergebenes Incident aus dem Client.
         * @param {Incident} incident
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postIncident(incident, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postIncident(incident, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * IncidentsApi - factory interface
 * @export
 */
export const IncidentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IncidentsApiFp(configuration);
    return {
        /**
         *
         * @summary Loggt ein übergebenes Incident aus dem Client.
         * @param {Incident} incident
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIncident(incident, options) {
            return localVarFp.postIncident(incident, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * IncidentsApi - object-oriented interface
 * @export
 * @class IncidentsApi
 * @extends {BaseAPI}
 */
export class IncidentsApi extends BaseAPI {
    /**
     *
     * @summary Loggt ein übergebenes Incident aus dem Client.
     * @param {Incident} incident
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentsApi
     */
    postIncident(incident, options) {
        return IncidentsApiFp(this.configuration).postIncident(incident, options).then((request) => request(this.axios, this.basePath));
    }
}
